(function () {
  const STORAGE_KEY = "wishlist";

  function readWishlistItems() {
    try {
      const stored = window.localStorage.getItem(STORAGE_KEY);
      const parsed = stored ? JSON.parse(stored) : null;
      return Array.isArray(parsed && parsed.items) ? parsed.items : [];
    } catch (error) {
      return [];
    }
  }

  function getWishlistVariantIds() {
    return new Set(
      readWishlistItems()
        .map((item) => String(item.variant_id || ""))
        .filter(Boolean),
    );
  }

  function renderWishlistPage(root) {
    const grid = root.querySelector("[data-wishlist-grid]");
    const empty = root.querySelector("[data-wishlist-empty]");
    const cards = Array.from(root.querySelectorAll("[data-wishlist-card]"));
    const wishedVariantIds = getWishlistVariantIds();

    let visibleCount = 0;

    cards.forEach((card) => {
      const show = wishedVariantIds.has(String(card.dataset.variantId));
      card.hidden = !show;
      if (show) visibleCount++;
    });

    if (grid) grid.hidden = visibleCount === 0;
    if (empty) empty.hidden = visibleCount !== 0;
  }

  function initWishlistPage(root) {
    renderWishlistPage(root);

    root.addEventListener("click", (event) => {
      if (!event.target.closest(".wishlist-btn")) return;

      setTimeout(() => renderWishlistPage(root), 180);
    });
  }

  document.addEventListener("DOMContentLoaded", () => {
    document.querySelectorAll("[data-wishlist-page]").forEach(initWishlistPage);
  });
})();
